import { RouteObject } from "react-router-dom";
import { PERMISSIONS } from "@miplatform/constants";
import { PATHS } from "../../routes/paths";
import { PATHS_PERMISSIONS } from "../../routes/pathsPermissions";

export const generateRoutesByPermissions = (
  routeList: IRoute[] = [],
  permissions: string[] = []
) => {
  if (permissions.includes(PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION)) {
    return routeList;
  }

  const paths = Object.values(PATHS);

  return routeList.filter((route) => {
    const routePath = route.path || "";

    const moduleKey = paths.find((basePath) => routePath.startsWith(basePath));
    const routePerms = PATHS_PERMISSIONS[routePath];

    if (!moduleKey && !routePerms) {
      return true;
    }

    const modulePerms = moduleKey ? PATHS_PERMISSIONS[moduleKey] : null;

    if (!modulePerms && !routePerms) {
      return true;
    }

    const allowed = [modulePerms || [], routePerms || []]
      .flat()
      .some((p) => permissions.includes(p));

    return allowed;
  });
};

export const generateNavItemsByPermissions = (
  navItemList: any[] = [],
  permissions: string[] = []
) => {
  if (permissions.includes(PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION)) {
    return navItemList;
  }

  const isPathAllowed = (path: string) => {
    const requiredPerms = PATHS_PERMISSIONS[path];

    if (!requiredPerms) {
      return true;
    }

    return requiredPerms.some((p) => permissions.includes(p));
  };

  const filterNavItem = (item: INavItem): any => {
    const isAllowed = !item.path || isPathAllowed(item.path);

    if (!isAllowed) {
      return null;
    }

    const hasChildren = Array.isArray(item.items) && item.items.length > 0;

    if (hasChildren) {
      const items = item.items ?? [];
      const filteredItems: (INavItem | null)[] = items
        .map(filterNavItem)
        .filter(Boolean);

      if (filteredItems.length > 0) {
        return {
          ...item,
          items: filteredItems,
        };
      }
    }

    return item;
  };

  return navItemList.map(filterNavItem).filter(Boolean);
};

export interface IRoute {
  path?: string;
  element?: React.ReactNode;
  name?: string;
  children?: IRoute[] | RouteObject[];
  permissionName?: string;
  exact?: boolean;
}

export interface INavItem {
  name: string;
  icon?: string;
  path?: string;
  permissionName?: string[];
  testId: string;
  group?: string;
  items?: INavItem[];
  disabled?: boolean;
}
